export enum InputType {
  TextField = "TEXT_FIELD",
  DropDown = "DROP_DOWN",
  Checkbox = "CHECKBOX",
  Radio = "RADIO",
  Multiline = "MULTILINE"
}